module.exports = __webpack_public_path__ + "media/images/athletes/2238-1c3386b3f5e73454eb5305b767559c24.png";